import React from "react";
import { Button } from "react-bootstrap";
import CustomCss from "./CustomCss";


class LayoutSettings extends React.Component{
    render(){

        const { activeSetting, getThemeSetting, activesettingLayout, cardStyle, wall } = this.props; 
        return(
        <>
            <div className="layout-settings px-3">
                <div className="pb-3">
                    <label className="card-label font-weight-bolder text-dark mb-0">Layout Settings</label>
                </div>
                <div className="settings-list">
                  { (![74,76,77].includes(cardStyle.themeId)) ?  
                    <Button onClick={()=>activeSetting(2)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                        <span className="ms-0 fs-9 fw-medium">Background</span>
                        <i className="menu-arrow"></i>
                    </Button> : null }
                    <Button onClick={()=>activeSetting(3)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                        <span className="ms-0 fs-9 fw-medium">Banner</span>
                        <i className="menu-arrow"></i>
                    </Button>
                    <Button onClick={()=>activeSetting(4)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                        <span className="ms-0 fs-9 fw-medium">Card Style</span>
                        <i className="menu-arrow"></i>
                    </Button>
                    <Button onClick={()=>activeSetting(5)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                        <span className="ms-0 fs-9 fw-medium">Theme Settings</span>
                        <i className="menu-arrow"></i>
                    </Button>

                    { getThemeSetting.cssStatus ?  
                    <Button onClick={()=>activeSetting(6)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                        <span className="ms-0 fs-9 fw-medium">Custom CSS</span>
                        <i className="menu-arrow"></i>
                    </Button> : null }

                    { (![63, 67,69,71,73,65,71].includes(cardStyle.themeId)) ?  
                    <Button onClick={()=>activeSetting(7)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                        <span className="ms-0 fs-9 fw-medium">Hashtag Highlighter</span>
                        <i className="menu-arrow"></i>
                    </Button> : null }
 
                    <Button onClick={()=>activeSetting(8)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                        <span className="ms-0 fs-9 fw-medium">Reactions <span className="new-tag ms-2">New</span></span>
                        <i className="menu-arrow"></i>
                    </Button>
                    <Button onClick={()=>activeSetting(9)} variant="default" className="d-flex align-items-center justify-content-between w-100 mb-3 text-dark btn-secondary-personalize">
                         <span className="ms-0 fs-9 fw-medium"> QR Setting </span>
                         <i className="menu-arrow"></i>
                     </Button> 
                    
                </div>
            </div>
              { activesettingLayout && getThemeSetting.cssStatus ? <CustomCss activesettingLayout={activesettingLayout}  {...this.props} /> : null }
        </>
            )
    }
}

export default LayoutSettings;